// Failure handling shared by the Google, Apple and Facebook sign-in flows.
App.namespace('es6.shared.social_login_error', () => {
  const CONTAINER_ID = 'socialLoginErrorContainer';
  const MESSAGE_ID = 'socialLoginError';

  // Sign-ins the backend refuses for a reason worth telling the user about – a banned email, an
  // email awaiting confirmation on another account, a deleted account – come back as 422 with a
  // ready-to-display message. Anything else is a fault they can only retry, and the caller's own
  // wording is friendlier than whatever the server happened to say.
  const getRefusalMessage = (jqXHR) => {
    const errors = jqXHR && jqXHR.responseJSON ? jqXHR.responseJSON.errors : null;

    return Array.isArray(errors) && errors.length > 0 ? errors[0] : null;
  };

  // Server-rendered pages carry the container next to their social buttons; Vue surfaces pass
  // their own `onError` handler instead and never reach this.
  const show = (message) => {
    const container = document.getElementById(CONTAINER_ID);
    const messageNode = document.getElementById(MESSAGE_ID);

    if (!container || !messageNode) {
      alert(message);
      return;
    }

    messageNode.innerText = message;
    container.classList.remove('none');
  };

  return {
    getRefusalMessage,
    show,
  };
});
